module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0158.jpg?v=6fda8976";